import { render, staticRenderFns } from "./table.vue?vue&type=template&id=73170941&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73170941",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73170941')) {
      api.createRecord('73170941', component.options)
    } else {
      api.reload('73170941', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=73170941&scoped=true", function () {
      api.rerender('73170941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolUpdate/components/table.vue"
export default component.exports